import React from "react";
import PropTypes from "prop-types";

import Component from "components/component";

export default class SizeOptionSelection extends Component {
  static propTypes = {
    customValue: PropTypes.string,
    isCustom: PropTypes.bool.isRequired,
    optionName: PropTypes.string,
    selectionName: PropTypes.string,
    displayPrice: PropTypes.string,
    quantityCount: PropTypes.number.isRequired
  };

  render() {
    const {
      selectionName,
      optionName,
      isCustom,
      customValue,
      displayPrice,
      quantityCount
    } = this.props;

    let quantityDisplay = null;

    if (quantityCount > 1) {
      quantityDisplay = `× ${quantityCount}`;
    }

    return (
      <div className="option-selection-wrapper">
        <p className="option-name">{optionName}</p>

        {isCustom && (
          <p className="option-value">
            {customValue}" (Custom) | {displayPrice} {quantityDisplay}
          </p>
        )}

        {!isCustom && (
          <p className="option-value">
            {selectionName}" | {displayPrice} {quantityDisplay}
          </p>
        )}
      </div>
    );
  }
}
